<template>
  <nuttrema-layout-west-slide width="35%" minWidth="45em">
    <west-slide-left-navigation slot="navigation-top">
      <a @click="closePage" :title="$t('label.close')">
        <nuttrema-iconica-sidebar-link icon="far fa-times" theme="white"></nuttrema-iconica-sidebar-link>
      </a>
    </west-slide-left-navigation>
    <!-- end ~ navigation-top -->

    <nuttrema-layout-east-block>
      <nuttrema-layout-west-three-vertical>
        <div slot="top-center" class="top--center__title">
          <span>{{ $t(title) }}</span>
        </div>
        <div slot="top-right" class="top--right__link">
          <el-button type="text" :title="$t('label.toc')" @click="toggleTableOfContent">
            <i class="fal fa-list"></i>
          </el-button>
        </div>
        <template slot="center">
          <nuttrema-loader v-if="loading"></nuttrema-loader>
          <template v-else>
            <div
               class="page-help-overlay__toc"
              :class="{ 'is-visible': showTableOfContent }"
              @click="onTableOfContentAnchorClick">
              <p class="page-help-overlay__toc__title">{{ $t('label.toc') }}</p>
              <div id="toc-content" class="page-help-overlay__toc__content"></div>
            </div>
            <!-- toc-id="toc" -->
            <vue-markdown
               ref="markdown"
               class="markdown-body"
               toc-id="toc-content"
              :source="help"
              :anchor="true"
              :toc="toc"
              :toc-anchor-link="false"
              @toc-rendered="checkAutoScroll">
            </vue-markdown>
          </template>
        </template>
      </nuttrema-layout-west-three-vertical>
    </nuttrema-layout-east-block>

  </nuttrema-layout-west-slide>
</template>

<script>
import Vue from 'vue';
import VueMarkdown from 'vue-markdown';
import Emitter from 'components/mixins/emitter';

import { get } from 'lodash';

import PageProps from 'components/mixins/page-props';
import NuttremaLayoutWestSlide from 'components/ui/layout/nuttrema-layout-west-slide';

import NuttremaLayoutEastBlock from 'components/ui/layout/nuttrema-layout-east-block';
import NuttremaLayoutWestThreeVertical from 'components/ui/layout/nuttrema-layout-west-three-vertical';

import WestSlideLeftNavigation from 'components/ui/west-slide-component/west-slide-left-navigation';
import NuttremaIconicaSidebarLink from 'components/ui/label/nuttrema-iconica-sidebar-link';

export default {
  name: 'page-help-overlay',
  mixins: [
    Emitter,
    PageProps,
  ],
  props: {
    file: {
      type: String,
      required: true,
      default: null,
    },
    anchor: {
      required: false,
      default: null,
    },
    title: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      loading: true,
      help: null,
      toc: true,
      showTableOfContent: false,
      tocText: null,
    };
  },
  methods: {
    closePage() {
      this.$emit('close');
    },
    toggleTableOfContent() {
      // this.toc = !this.toc;
      this.showTableOfContent = !this.showTableOfContent;
    },
    scrollContent(anchor) {
      const target = anchor.replace('#', '');
      this.broadcast('NuttremaLayoutWestThreeVertical', 'scrollContent', target);
    },
    onTableOfContentAnchorClick(evt) {
      this.showTableOfContent = false;
      evt.preventDefault();
      const hash = get(evt, 'target.hash', false);
      if (hash) {
        this.scrollContent(hash);
      }
    },
    checkAutoScroll() {
      if (this.anchor) {
        this.$nextTick(() => {
          this.scrollContent(this.anchor);
        });
      }
    },
  },
  components: {
    VueMarkdown,
    WestSlideLeftNavigation,
    NuttremaLayoutEastBlock,
    NuttremaLayoutWestSlide,
    NuttremaIconicaSidebarLink,
    NuttremaLayoutWestThreeVertical,
  },
  created() {
    const baseURL = get(window, 'location.origin');

    const axios = Vue.axios.create({
      baseURL,
    });

    const language = this.$locale.current();
    const file = `static/help/${this.file}_${language}.md`;

    this.help = '# Help file missing!';

    axios.get(file)
      .then((response) => {
        this.help = response.data;
        this.loading = false;
      })
      .catch((error) => {
        console.log(error);
        this.loading = false;
      });
  },
};
</script>

<style lang="scss" scoped>
  .page-help-overlay__toc {
    width: 100%;
    padding: 1em;
    position: fixed;
    visibility: hidden;
    border-bottom: 2px solid #dbe2ef;
    background-color: rgba(255,255,255, 0.95);

    &.is-visible {
      visibility: visible;
    }

    .page-help-overlay__toc__title {
      font-weight: 500;
      padding: 0 0 0.5em 0.5em;
      margin-bottom: 0.5em;
      font-style: 1.15em;
      border-bottom: 1px solid gray;
    }

    .page-help-overlay__toc__content {
      padding: 0 0.5em;
      /deep/ .table-of-contents {
        a {
          color: gray;
          &:hover, &:focus, &:active {
            text-decoration: underline;
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/shared/help/page-help-overlay.vue